export const usersJson = {
    "1": {
        id: 1,
        name: "salman khan",
        username: "salmankhan",
        url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
    },
    "2": {
        id: 2,
        name: "demo02",
        username: "demo02",
        url: null
    },
    "3": {
        id: 3,
        name: "Abdulaziz Al Khaldi",
        username: "azizalkhaldi",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
    },
    "4": {
        id: 4,
        name: "Momeento News",
        username: "momeento_news",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
    },
    "5": {
        id: 5,
        name: "Richard Kettleboroug",
        username: "richard11",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
    },
    "6": {
        id: 6,
        name: "Satish Chauhan",
        username: "demo32",
        url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
    },
    "7": {
        id: 7,
        name: "shah rukh khan",
        username: "shahrukhkhan",
        url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
    },
    "8": {
        id: 8,
        name: "Al Khaldi",
        username: "alkhaldi",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
    }
};

export const usersArray: DemoUserObject[] = Object.values(usersJson);

export type DemoUserObject = {
    id: string | number;
    name: string;
    username: string;
    url: string | null;
};

export type DemoUserListObject = DemoUserObject & {
    status: "active" | "blocked" | "deleted";
};

export const usersListArray: DemoUserListObject[] = usersArray.map((u, i) => ({
    ...u,
    status: i % 2 === 0 ? "active" : i % 3 === 0 ? "blocked" : "deleted"
}));
